export const defaultScript = [
  {
    type: "text",
    text: "Hey, are you free to talk?",
    sender: "You",
    voice: "alloy",
    delay: 1200,
    collapsed: true,
    vibe: {
      preset: "Custom",
      open: false,
      identity: "",
      personality: "",
      voice: "",
      dialect: "",
      voiceAffect: "",
      tone: "",
      emotion: "",
      affect: "",
      speechMannerisms: "",
      pronunciation: "",
      delivery: "",
      phrasing: "",
      emphasis: "",
      tempo: "",
      pacing: "",
      pauses: "",
      features: "",
    },
  },
  {
    type: "text",
    text: "What’s going on?",
    sender: "Friend",
    voice: "echo",
    delay: 1500,
    collapsed: true,
    vibe: {
      preset: "Custom",
      open: false,
      identity: "",
      personality: "",
      voice: "",
      dialect: "",
      voiceAffect: "",
      tone: "",
      emotion: "",
      affect: "",
      speechMannerisms: "",
      pronunciation: "",
      delivery: "",
      phrasing: "",
      emphasis: "",
      tempo: "",
      pacing: "",
      pauses: "",
      features: "",
    },
  },
];
